import json from './sprite.js';

export default {
    handle: 'ENG_SPS3-NewFriends',
    label: 'en_SPS3-NewFriends_225002362',
    json,
};
